<template>
  <div class="header">
    <v-navigation-drawer v-model="drawer" app right width="300" class="sidebar">
      <div class="sidebar__avatar-wrapper">
        <div class="top-logo">
          <img :src="info.thumbLogoAddress" width="100%" :alt="info.title" />
        </div>
      </div>

      <v-list>
        <template v-for="(nav, navIndex) in navItems">
          <v-list-item
            v-if="nav.to"
            :key="`${navIndex}-a`"
            :to="{ name: nav.to }"
            link
            dark
          >
            <v-list-item-icon>
              <v-icon small>{{ nav.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ nav.label }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group
            v-if="nav.subItems"
            :key="`${navIndex}-b`"
            :prepend-icon="`${nav.icon} fa-em`"
            v-model="nav.active"
            append-icon="fas fa-chevron-down fa-sm"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ nav.label }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <span v-for="(sub, subIndex) in nav.subItems" :key="subIndex">
              <v-list-item :to="{ name: sub.to }" link dark>
                <v-list-item-icon>
                  <v-icon small>{{ sub.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="p-fs-n">{{
                    sub.label
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <hr v-if="sub.divider" />
            </span>
          </v-list-group>
          <v-divider
            color="#0e485b "
            class="my-2 mx-2"
            :key="navIndex"
            v-if="nav.to || (nav.subItems && nav.subItems.length > 0)"
          />
        </template>
      </v-list>

      <span class="sidebar-bottom-caption">
        powered by Parvaz E-Commerce v {{ version }}
      </span>
    </v-navigation-drawer>

    <v-app-bar flat color="white" app>
      <v-btn
        @click="toggleSidebar()"
        class="drawer-hide"
        elevation="0"
        fab
        v-if="drawer"
        ><i class="fas fa-chevron-right"></i>
      </v-btn>
      <v-btn
        @click="toggleSidebar()"
        class="drawer-show"
        elevation="0"
        fab
        v-else
        ><i class="fas fa-bars"></i>
      </v-btn>

      <v-toolbar-title>
        <div class="d-flex">
          <h2 class="ms-5 ps-4 p-fs-m first--text">مدیریت فروشــگاه فــــرنـــام</h2>
        </div>
      </v-toolbar-title>

      <v-tooltip left color="primary">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="p-table-top-btn mr-2"
              color="second"
              depressed
              small
              text
              @click="config"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-cog</v-icon>
            </v-btn>
        </template>
        <span> اطلاعات شرکت / سازمان</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- <NotifyDropDown /> -->

      <!-- <MessageDropDown /> -->
      <AccountDropDown />
    </v-app-bar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";
import navItems from "@/containers/navbar.js";
import AccountDropDown from "./dropDown/Account";

export default {
  name: "TheHeader",
  components: {
    AccountDropDown,
  },
  data() {
    return {
      yearModal: false,
      alert,
      label,
      drawer: null,
      navItems,
      selctedYear: null,

      version: process.env.VUE_APP_VERSION,
    };
  },
  computed: {
    ...mapGetters({
      loadingBtn: "loadingBtn",
      info: "baseX/config",
    }),
  },
  methods: {
    close() {
      this.yearModal = false;
    },
    config() {
      this.$router.push({ name: "Config" });
    },
    toggleSidebar() {
      this.drawer = !this.drawer;
    },
    logout() {
      this.$store.dispatch("logout");
    },
  },
  mounted() {
    this.$store.dispatch("baseX/getConfig");
  }
};
</script>